import React from "react";

function createIcon(paths, viewBox) {
  return function MerchantIcon() {
    return (
      <svg width="16" height="16" viewBox={viewBox || "0 0 16 16"} fill="none">
        {paths.map(function renderPath(path, index) {
          return React.createElement(path.tag, {
            key: index,
            ...path.props,
          });
        })}
      </svg>
    );
  };
}

export const MerchantDashboardIcon = createIcon([
  { tag: "rect", props: { x: "1", y: "1", width: "6", height: "6", rx: "1.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "rect", props: { x: "9", y: "1", width: "6", height: "6", rx: "1.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "rect", props: { x: "1", y: "9", width: "6", height: "6", rx: "1.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "rect", props: { x: "9", y: "9", width: "6", height: "6", rx: "1.5", stroke: "currentColor", strokeWidth: "1.5" } },
]);

export const MerchantTransactionsIcon = createIcon([
  { tag: "path", props: { d: "M2 4h12M2 8h9M2 12h6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" } },
]);

export const MerchantSettlementsIcon = createIcon([
  { tag: "rect", props: { x: "2", y: "3", width: "12", height: "10", rx: "1.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "path", props: { d: "M2 6.5h12M6 9.5h1.5M9.5 9.5H11", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" } },
]);

export const MerchantOutletsIcon = createIcon([
  { tag: "path", props: { d: "M2 7.5L8 3l6 4.5v6a1 1 0 01-1 1H3a1 1 0 01-1-1v-6z", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "path", props: { d: "M6 14V9.5h4V14", stroke: "currentColor", strokeWidth: "1.5" } },
]);

export const MerchantReportsIcon = createIcon([
  { tag: "rect", props: { x: "3", y: "2", width: "10", height: "12", rx: "1.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "path", props: { d: "M5.5 6h5M5.5 8.5h5M5.5 11h3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" } },
]);

export const MerchantUsersIcon = createIcon([
  { tag: "circle", props: { cx: "8", cy: "5.5", r: "2.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "path", props: { d: "M2.5 14c0-3 2.5-4.5 5.5-4.5s5.5 1.5 5.5 4.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" } },
]);

export const MerchantSettingsIcon = createIcon([
  { tag: "circle", props: { cx: "8", cy: "8", r: "2.5", stroke: "currentColor", strokeWidth: "1.5" } },
  { tag: "path", props: { d: "M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" } },
]);

export const MerchantMoreIcon = createIcon([
  { tag: "circle", props: { cx: "3", cy: "8", r: "1.25", fill: "currentColor" } },
  { tag: "circle", props: { cx: "8", cy: "8", r: "1.25", fill: "currentColor" } },
  { tag: "circle", props: { cx: "13", cy: "8", r: "1.25", fill: "currentColor" } },
], "0 0 16 16");

export function MerchantSearchIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10 10l2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function MerchantBellIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 2a5 5 0 00-5 5c0 2.5-1 4-1 4h12s-1-1.5-1-4a5 5 0 00-5-5zM9.5 13.5a1.5 1.5 0 01-3 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function MerchantSignOutIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M5 12H2.5a1 1 0 01-1-1V3a1 1 0 011-1H5M9.5 10l3-3-3-3M12.5 7H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function MerchantDownloadIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path d="M6.5 1v8M3 6l3.5 3.5L10 6M2 11.5h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function MerchantPlusIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path d="M6.5 2v9M2 6.5h9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function MerchantBackIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M10 12L6 8l4-4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
